import { Injectable } from '@angular/core';
import { CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivateChild {

  constructor(private router: Router) {}

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const isLoggedIn = !!sessionStorage.getItem('auth'); // 👈 example check

    if (!isLoggedIn) {
      // 🚫 Not logged in → redirect to login
      this.router.navigate(['/login']);
      return false;
    }

    return true;
  }
}
